import { render, staticRenderFns } from "./bestelluebersicht.vue?vue&type=template&id=02874f4a&scoped=true&"
import script from "./bestelluebersicht.vue?vue&type=script&lang=js&"
export * from "./bestelluebersicht.vue?vue&type=script&lang=js&"
import style0 from "./bestelluebersicht.vue?vue&type=style&index=0&id=02874f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02874f4a",
  null
  
)

export default component.exports